export class SensitivityLabelsDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "hasSensitivityLabels",
            "baseName": "hasSensitivityLabels",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SensitivityLabelsDetails.attributeTypeMap;
    }
    constructor() {
    }
}
